module.exports = __webpack_public_path__ + "img/teasergenuine.bd485de0.png";